const data = require("./seo-data.json");

const configuredUrl = process.env.REACT_APP_SITE_URL;
if (!configuredUrl) throw new Error("REACT_APP_SITE_URL is required for canonical SEO URLs");
const base = new URL(configuredUrl);
if (base.protocol !== "https:") throw new Error("REACT_APP_SITE_URL must use HTTPS");
const SITE_URL = base.origin;
const normalizePath = (pathname) => pathname.split(/[?#]/)[0].replace(/\/+$/, "") || "/";
const canonicalUrl = (pathname) => `${SITE_URL}${normalizePath(pathname)}`;

function structuredData(path, page, image) {
  const url = canonicalUrl(path);
  const home = canonicalUrl("/");
  const organizationId = `${home}#organization`;
  const websiteId = `${home}#website`;
  const graph = [
    {
      "@type": "Organization", "@id": organizationId,
      name: "PT HAQILA GLOBAL TRADING", alternateName: "HAQILA", url: home,
      logo: data.logo,
      description: "Indonesian commodity sourcing and export partner working with selected independent Indonesian manufacturing partners.",
      email: process.env.REACT_APP_BUSINESS_EMAIL,
      address: { "@type": "PostalAddress", addressLocality: "Tangerang", addressRegion: "Banten", addressCountry: "ID" },
    },
    { "@type": "WebSite", "@id": websiteId, name: "HAQILA", url: home, publisher: { "@id": organizationId }, inLanguage: "en" },
    {
      "@type": page.type || "WebPage", "@id": `${url}#webpage`, url,
      name: page.title, description: page.description,
      isPartOf: { "@id": websiteId }, publisher: { "@id": organizationId }, inLanguage: "en",
      primaryImageOfPage: { "@type": "ImageObject", url: image.url, caption: image.alt },
      ...(path !== "/" ? { breadcrumb: { "@id": `${url}#breadcrumb` } } : {}),
    },
  ];
  if (path !== "/") {
    const paths = ["/", ...(page.parent ? [page.parent] : []), path];
    graph.push({
      "@type": "BreadcrumbList", "@id": `${url}#breadcrumb`,
      itemListElement: paths.map((item, index) => ({
        "@type": "ListItem", position: index + 1, name: data.pages[item].name, item: canonicalUrl(item),
      })),
    });
  }
  return { "@context": "https://schema.org", "@graph": graph };
}

function getPageSeo(pathname) {
  const path = normalizePath(pathname);
  const page = data.pages[path];
  if (!page) return {
    title: path.startsWith("/admin") ? "HAQILA Admin" : "Page Not Found | HAQILA",
    description: "", robots: "noindex, nofollow", canonical: null, image: null, jsonLd: null,
  };
  const image = data.images[page.image];
  return {
    ...page, image, canonical: canonicalUrl(path), robots: "index, follow, max-image-preview:large",
    jsonLd: structuredData(path, page, image),
  };
}

module.exports = { getPageSeo, canonicalUrl, normalizePath, pages: data.pages };